/** @format */

import React, { useState, useMemo, useContext } from "react";
import { Context } from "../stores/Provider";
import { getSession } from "../sessionStorage/sessionStorageMethod";
import { setIsLoading } from "../function/setIsLoading";
import { logoutAbnormalFunction } from "../function/logoutAbnormalFunction";
import { initApiModelType, inquirySendRequestType } from "../constance/typeModel";
import { initApiResponse } from "../constance/constance";
import { PostMethod } from "../api/Api";

const useInquirySendHooks = (navigateByAgent: Function) => {
  const { state, dispatch } = useContext(Context);
  const userInfoData = getSession("user");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const modalOpenHandler = () => {
    setIsModalOpen((prev) => !prev);
    setIsSubmitted(false);
  };
  // お問い合わせ作成用のState
  const [inquiryRegister, setInquiryRegister] = useState({ title: "", content: "", name: "", email: "" });

  // お問い合わせバリデーションState
  const [errMsg, setErrMsg] = useState({ text: "", select: "" });

  // お問い合わせState変更関数
  const setInquiryRegisterHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInquiryRegister({ ...inquiryRegister, [e.target.id]: e.target.value });
  };

  // ヘッダーロゴ切り替えるために利用
  const zAccount = state.zAccount;

  //お問い合わせブランクバリデーション
  const setErrMsgHandler = (
    inquiryName: string,
    inquiryEmail: string,
    inquiryContent: string,
    inquiryTitle: string,
  ) => {
    let insertErrMsg = { text: "", select: "" };
    if (inquiryName === "" || inquiryEmail === "" || inquiryContent === "") {
      insertErrMsg = {
        ...insertErrMsg,
        text: "お名前、メールアドレス、お問い合わせ内容(詳細)をすべてを入力してください。",
      };
    }
    if (inquiryTitle === "") {
      insertErrMsg = { ...insertErrMsg, select: "お問い合わせ内容を選択してください。" };
    }
    return insertErrMsg;
  };

  //コンテンツ選択セレクトメニュー
  const selectOption = useMemo(
    () => [
      { label: "コンテンツを選択", value: "", disabled: false },
      { label: "申し込みについて", value: "申し込みについて", disabled: false },
      { label: "審査について", value: "審査について", disabled: false },
      { label: "申し込みのキャンセル", value: "申し込みのキャンセル", disabled: false },
      { label: "その他", value: "その他", disabled: false },
    ],
    [],
  );

  const inquiryRegisterHandler = async () => {
    const inquiryTitle = inquiryRegister.title;
    const inquiryContent = inquiryRegister.content;
    const inquiryName = inquiryRegister.name;
    const inquiryEmail = inquiryRegister.email;
    let response: initApiModelType<undefined> = initApiResponse;

    if (inquiryName === "" || inquiryEmail === "" || inquiryContent === "" || inquiryTitle === "") {
      setErrMsg(setErrMsgHandler(inquiryName, inquiryEmail, inquiryContent, inquiryTitle));
      return response;
    }

    setErrMsg({ text: "", select: "" });
    const reqData = {
      name: inquiryName,
      entry_id: userInfoData.entry_id,
      email: inquiryEmail,
      content: inquiryTitle,
      detail: inquiryContent,
    };
    setIsLoading(true, dispatch);
    response = await PostMethod<inquirySendRequestType, undefined>(reqData, "/inquiry_send");
    if (response.code === 200) {
      setIsSubmitted(true);
      setInquiryRegister({ title: "", content: "", name: "", email: "" });
    } else if (response.code === 401) {
      return logoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
    } else {
      setIsSubmitted(false);
      return navigateByAgent("/system_error");
    }
    setIsLoading(false, dispatch);
  };

  return {
    isSubmitted,
    isModalOpen,
    selectOption,
    modalOpenHandler,
    setInquiryRegisterHandler,
    inquiryRegisterHandler,
    errMsg,
    zAccount,
  };
};

export default useInquirySendHooks;
